import { defineStore } from 'pinia'
import { useAgeVerificationStore } from './age-verification'
import { Platform } from 'quasar'
import { convertArrayToObject } from 'src/utils'
import { useCustomerStore } from 'src/stores/customer'
import { useAuthStore } from 'src/stores/auth'
import { usePersistedStore } from 'src/stores/persisted'
import { useCommonStore } from 'src/stores/common'

export const useDiscountStore = defineStore('discounts', {
  state: () => ({
    page: 1,
    pageSize: 10,
    hasMoreDiscount: false,
    discounts: {},
    loading: true,
    loadingMore: false,
    currentDiscount: null,
    loadingCurrentDiscount: false,
    products: {},
  }),
  actions: {
    async getDiscounts(params = {}) {
      try {
        const ageVerificationStore = useAgeVerificationStore()
        const customerStore = useCustomerStore(),
          authStore = useAuthStore(),
          persistedStore = usePersistedStore(),
          commonStore = useCommonStore()

        if (
          (params?.hasOwnProperty('loadMore') && this.hasMoreDiscount) ||
          (!params?.hasOwnProperty('loadMore') && this.page == 1)
        ) {
          if (this.page == 1) this.loading = true
          if (this.page !== 1) this.loadingMore = true

          let rParams = {
            locationID: persistedStore.currentLocationId,
            page: this.page,
            pageSize: this.pageSize,
            ...commonStore.currentDeliveryModes,
          }

          const isLoggedIn = authStore.isLoggedIn
          if (
            ageVerificationStore.skipBrowsingAgeRestrictedProd &&
            ((!isLoggedIn &&
              !persistedStore.eaivPersistedVerificationSuccess) ||
              (isLoggedIn && !customerStore.customer?.isVerifiedOnline))
          ) {
            rParams.skipBrowsingAgeRestrictedProd = true
          }

          let { data } = await this.$axiosInstance.get('/discount', {
            params: rParams,
          })

          if (data?.success) {
            const discountsData = data.data || []
            this.discounts = Object.assign(
              {
                ...this.discounts,
              },
              convertArrayToObject(discountsData.items, 'discountID')
            )
            this.hasMoreDiscount = discountsData.hasNext
            this.page += 1
          }
        }
      } catch (err) {
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },
    async getDiscountDetail(seoName) {
      const commonStore = useCommonStore()

      if (!seoName) return false
      let discount = this.discounts[seoName]

      if (discount) {
        this.currentDiscount = discount

        if (Platform?.is?.mobile)
          commonStore.setHeaderTitle({ title: discount.discountName })

        return true
      }

      this.loadingCurrentDiscount = true
      try {
        const persistedStore = usePersistedStore()
        let response = await this.$axiosInstance.get(`/discount/${seoName}`, {
          params: {
            locationID: persistedStore.currentLocationId,
            ...commonStore.currentDeliveryModes,
          },
        })

        discount = response?.data?.data
        if (!discount) return

        this.currentDiscount = discount

        if (Platform?.is?.mobile)
          commonStore.setHeaderTitle({ title: discount.discountName })
        return true
      } catch (e) {
        return false
      } finally {
        this.loadingCurrentDiscount = false
      }
    },
    getTriggerProductList({ discountId, params }) {
      const ageVerificationStore = useAgeVerificationStore()
      const customerStore = useCustomerStore()
      const authStore = useAuthStore()
      const persistedStore = usePersistedStore()

      const isLoggedIn = authStore.isLoggedIn
      const shouldSkipAgeRestricted =
        ageVerificationStore.skipBrowsingAgeRestrictedProd &&
        ((!isLoggedIn && !persistedStore.eaivPersistedVerificationSuccess) ||
          (isLoggedIn && !customerStore.customer?.isVerifiedOnline))

      return this.$axiosInstance.get(`/discount/${discountId}/triggerproduct`, {
        params: {
          ...params,
          ...(shouldSkipAgeRestricted && {
            skipBrowsingAgeRestrictedProd: true,
          }),
        },
      })
    },
  },
})
